import BaseTransformer from "./base.transformer"
export const baseUri = "/api/themes"

class ThemeTransformer extends BaseTransformer {
  static fetch(theme) {
    const uuid = this.transformUuid(theme)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      title: theme.title,
      type: theme.type,
      content: theme.data,
      previewContent: theme.previewContent,
      isSysDefault: theme.isSysDefault
    })
  }
}

export default ThemeTransformer
